export default __webpack_public_path__ + "static/media/Lea4Cast.bc916f98.gif";